import { TeamAccessDTO } from '../team/team-access.dto';

export class ManuscriptListDTO extends TeamAccessDTO {

    name: string;

    content: string;

    type: number;
    
}
